import { render, staticRenderFns } from "./customers_active.vue?vue&type=template&id=6d42ae07&lang=pug"
import script from "./customers_active.vue?vue&type=script&lang=js"
export * from "./customers_active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports